import ElCarouselItem from '../carousel/src/item';

/* istanbul ignore next */
ElCarouselItem.install = function(Vue) {
  Vue.component(ElCarouselItem.name, ElCarouselItem);
};

export default ElCarouselItem;



// WEBPACK FOOTER //
// ./packages/carousel-item/index.js